



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VNumericInput from "@/components/VNumericInput.vue";
import FileUploader from "@/components/FileUploader.vue";
import VMultiTuple from "@/components/VMultiTuple.vue";
import VTuple from "@/components/VTuple.vue";
import { Blueprint } from "@/models";
import { parse } from "uuid";

@Component({
  components: {
    VModal,
    VMultiTuple,
    VTuple,
    FileUploader,
    VNumericInput,
  },
})
export default class BlueprintFields extends Vue {
  @Prop({ required: true }) readonly value!: Blueprint;
  @Prop({ default: false }) readonly replace!: boolean;

  item = { ...this.value };
  changeAttachment = false;

  onFileAdded(file) {
    this.changeAttachment = true;
    this.$nextTick(() => {
      if (!file.name.endsWith("obj")) {
        this.item.blueprint = null;
      } else {
        this.item.blueprint = file;
      }
    });
  }

  onDetachFile() {
    this.item.blueprint = null;
  }

  @Watch("item", { deep: true })
  onItemChanged() {
    this.$emit("input", this.item);
  }
}
